import { Grid } from '@material-ui/core';
import { GroupEntity } from '@backstage/catalog-model';
import { OrphanedSecretsTable } from './OrphanedSecretsTable';
import { OrphanedVulnerabilitiesTable } from './OrphanedVulnerabilitiesTable';
import { RenovateGuideCard } from '@internal/backstage-plugin-renovate-stats';
import { RenovateStackedBarChart } from './RenovateStackedBarChart';
import { ScoreBoardType } from './ScoreBoardType';
import { SecretsRotationGuideCard } from '@internal/backstage-plugin-aws-services';
import { SecretsStackedBarChart } from './SecretsStackedBarChart';
import { useEntity } from '@backstage/plugin-catalog-react';
import { VulnerabilitiesGuideCard } from '@internal/backstage-plugin-zf-vulnerabilities';
import { VulnerabilityStackedBarChart } from './VulnerabilityStackedBarChart';

import { InfoCard, Progress } from '@backstage/core-components';
import { ScoreIndex, useTeamList } from '@internal/ui-common';

const ENG_HEAD_DEPARTMENT_PREFIX = 'eng-head';

export const ScoreBoard = <T,>({
  type,
  scores,
}: {
  type: string;
  scores?: ScoreIndex<T>[];
}): React.ReactElement => {
  const { entity: departmentGroup } = useEntity<GroupEntity>();
  const { teams, isLoading } = useTeamList(departmentGroup);

  if (isLoading || !scores) {
    return <Progress />;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        {type === ScoreBoardType.RENOVATE && <RenovateGuideCard />}
        {type === ScoreBoardType.SECRETS && <SecretsRotationGuideCard />}
        {type === ScoreBoardType.VULNERABILITIES && (
          <VulnerabilitiesGuideCard />
        )}
      </Grid>
      {type === ScoreBoardType.SECRETS && (
        <Grid item xs={12} md={12}>
          <InfoCard title="Secrets Across Teams">
            <SecretsStackedBarChart scores={scores as any} teams={teams} />
          </InfoCard>
        </Grid>
      )}
      {type === ScoreBoardType.RENOVATE && (
        <Grid item xs={12} md={12}>
          <InfoCard title="Renovate MRs Across Teams">
            <RenovateStackedBarChart scores={scores as any} teams={teams} />
          </InfoCard>
        </Grid>
      )}
      {type === ScoreBoardType.VULNERABILITIES && (
        <Grid item xs={12} md={12}>
          <InfoCard title="Vulnerabilities Across Teams">
            <VulnerabilityStackedBarChart
              scores={scores as any}
              teams={teams}
            />
          </InfoCard>
        </Grid>
      )}
      {departmentGroup?.metadata?.name?.startsWith(
        ENG_HEAD_DEPARTMENT_PREFIX,
      ) ? (
        <Grid item xs={12} md={12}>
          {type === ScoreBoardType.SECRETS && <OrphanedSecretsTable />}
          {type === ScoreBoardType.VULNERABILITIES && (
            <OrphanedVulnerabilitiesTable />
          )}
        </Grid>
      ) : null}
    </Grid>
  );
};
